import { KeyboardEventHandler } from "react";
import { FormErrorsSchema } from "../../types";

export const Input = ({
  label = undefined,
  name,
  key = undefined,
  placeholder = "",
  password = false,
  errors,
  value,
  setValue = undefined,
  required = false,
  disabled = false,
  inputMask = undefined,
  autoFocus = undefined,
  onKeyDown = undefined,
  onChange = undefined,
  inputRef = undefined,
  containerClassName = "w-full mt-6",
}: {
  label?: string;
  name: string;
  key?: string;
  placeholder?: string;
  password?: boolean;
  errors?: FormErrorsSchema;
  value: string;
  setValue?: Function | React.Dispatch<React.SetStateAction<string>>;
  required?: boolean;
  disabled?: boolean;
  inputMask?: Function;
  autoFocus?: boolean;
  onKeyDown?: KeyboardEventHandler<HTMLInputElement>;
  onChange?: Function;
  inputRef?: any;
  containerClassName?: string;
}) => {
  return (
    <div className={containerClassName} key={key}>
      {label && (
        <label htmlFor={name} className="block mb-2 font-medium text-gray-900">
          {label}
          {required && <span className="ml-1 text-red-500">*</span>}
        </label>
      )}
      <input
        type={password ? "password" : "text"}
        name={name}
        id={name}
        className="bg-gray-50 border-gray-300 text-gray-900 focus:border-brand-blue-400 focus:ring-0 focus:ring-gray-300 text-sm block w-full disabled:cursor-not-allowed disabled:bg-gray-200"
        placeholder={placeholder}
        autoComplete="off"
        value={value}
        onChange={async (e: React.ChangeEvent<HTMLInputElement>) => {
          const { name, value } = e.target;

          if (setValue) {
            
            setValue(inputMask ? inputMask(value) : value);
          }

          if (onChange) {
            await onChange(inputMask ? inputMask(value) : value, name);
          }
        }}
        required={required}
        disabled={disabled}
        autoFocus={autoFocus}
        onKeyDown={onKeyDown}
        ref={inputRef}
      />
      {errors?.[name]?.map((error) => (
        <p key={error} className="mt-2 text-sm text-red-600">
          {error}
        </p>
      ))}
    </div>
  );
};
